export default __webpack_public_path__ + "static/media/img_20.e0effb92.jpg";